import { IPerpAggregatedPosition } from "../interfaces/positions";

export interface IPerpDataOverviewRow {
  asset: string;
  instrumentName: string;
  netDelta: number;
  netDeltaUsd: number;
  markPrice: number;
  aevoNotionalUsd: number;
  binanceNotionalUsd: number;
  bybitNotionalUsd: number;
  hyperliquidNotionalUsd: number;
  lighterNotionalUsd: number;
  lighterMainnetNotionalUsd: number;
}

const venueNotionalUsd = (contracts: number, markPrice: number): number =>
  contracts * markPrice;

export const buildPerpOverviewRows = (
  positions: IPerpAggregatedPosition[]
): IPerpDataOverviewRow[] =>
  positions
    .map((position) => {
      const markPrice = position.markPrice ?? 0;
      const aevoMark = position.aevoMarkPrice || markPrice;
      const binanceMark = position.binanceMarkPrice || markPrice;
      const bybitMark = position.bybitMarkPrice || markPrice;
      const hyperliquidMark = position.hyperliquidMarkPrice || markPrice;
      const lighterMark = position.lighterMarkPrice || markPrice;

      return {
        asset: position.asset,
        instrumentName: position.instrument_name,
        netDelta: position.netDelta,
        netDeltaUsd: position.netDelta * markPrice,
        markPrice,
        aevoNotionalUsd: venueNotionalUsd(position.aevoDelta, aevoMark),
        binanceNotionalUsd: venueNotionalUsd(position.binanceDelta, binanceMark),
        bybitNotionalUsd: venueNotionalUsd(position.bybitDelta, bybitMark),
        hyperliquidNotionalUsd: venueNotionalUsd(position.hyperliquidDelta, hyperliquidMark),
        lighterMainnetNotionalUsd: position.lighterMainnetDelta * (position.lighterMainnetMarkPrice || position.markPrice),
        lighterNotionalUsd: venueNotionalUsd(position.lighterDelta, lighterMark),
      };
    })
    .sort((a, b) => a.asset.localeCompare(b.asset));
